import React, { Component } from "react";
import { Tooltip, Button } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class ClickToFill extends Component {
  state = { leftPosition: null, buttonDisplay: "none" };

  componentDidMount() {
    setTimeout(() => {
      this._setButtonPosition();
    }, 25);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.isToolpaneOpen !== this.props.isToolpaneOpen ||
      (prevProps.showOutlineView !== this.props.showOutlineView ||
        prevProps.toolpaneView !== this.props.toolpaneView)
    ) {
      this._setButtonPosition();
    }
  }

  _setButtonPosition = () => {
    const ele = document.getElementById("document-view-container");
    if (ele) {
      const { left } = ele.getBoundingClientRect();
      let leftPosition = left - 143;
      // In case of outline or right side toolpane are open,
      // then adjust the left position
      if (this.props.isToolpaneOpen || this.props.showOutlineView) {
        leftPosition = left - 50;
      }

      setTimeout(() => {
        this.setState({
          buttonDisplay: "unset",
          leftPosition,
        });
      }, 10);
    }
  };

  render() {
    const { formTop } = this.props;
    return (
      <Tooltip
        placement="top"
        overlay="Fill the form to quickly complete the document">
        <Button
          className={`click-to-fill ${
            this.props.isToolpaneOpen || this.props.showOutlineView
              ? " only-icon "
              : ""
          }`}
          onClick={this.props.toggleFormView}
          style={{
            top: formTop,
            left: this.state.leftPosition,
            display: this.state.buttonDisplay,
          }}
          data-test="clicktofill-start-filling-btn">
          <FontAwesomeIcon icon={["fal", "pen-alt"]} />
          {!this.props.isToolpaneOpen &&
            !this.props.showOutlineView &&
            "Start filling"}
        </Button>
      </Tooltip>
    );
  }
}

export default ClickToFill;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DocForm/ClickToFill.js